<template>
  <v-card>
    <div class="pt-6">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
              depressed
              color="primary"
              v-on:click="back()"
            >
              返回
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-5">
          <v-data-table
            :headers="headers"
            fixed-header
            :items="desserts"
            class="elevation-1 mt-2"
            :loading="loading"
            :server-items-length="totalDesserts"
            :page.sync="filter.pageNum"
            :items-per-page.sync="filter.pageSize"
            @update:page="handlePageChanged"
            @update:items-per-page="handlePageSizeChanged"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-btn color="primary" depressed class="mr-2" @click="doImport">
                  新增调改
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              {{ _jungleStatus(item.status) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn text color="primary" small @click="viewAdjust(item)"
                >查看</v-btn
              >
            </template>
          </v-data-table>
        </v-row>
      </v-card>
      <!--导入弹窗-->
      <v-dialog v-model="importDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
            >新增调改导入</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-file-input
                    truncate-length="15"
                    label="选择excel"
                    small-chips
                    dense
                    v-model="importFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleImport"> 确认 </v-btn>
            <v-btn color="primary" text @click="downloadTemplate">
              下载模板
            </v-btn>
            <v-btn text @click="hideImport"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--查看调改详情弹窗-->
      <v-dialog persistent v-model="viewDialog" width="1000">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
            >调改详情</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row class="d-flex padding-bottom mt-2">
                <div>
                  <v-btn
                    depressed
                    color="primary"
                    class="margin-left"
                    @click="clickPassed"
                    :disabled="adjustInfo.status!=1"
                  >
                    审批通过
                  </v-btn>
                  <v-btn
                    depressed
                    color="primary"
                    class="margin-left"
                    @click="clickUnpassed"
                    :disabled="adjustInfo.status!=1"
                  >
                    审批不通过
                  </v-btn>
                </div>
              </v-row>
              <v-row class="mt-4">
                <div class="scroll-wrapper">
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left" style="width: 100px; min-width: 100px;">
                            事项编号
                          </th>
                          <th class="text-left" style="width: 100px; min-width: 100px;">
                            所属科目
                          </th>
                          <th class="text-left" style="width: 180px; min-width: 180px;">
                            业务事项
                          </th>
                          <th class="text-left" style="width: 150px; min-width: 150px;">
                            修改项
                          </th>
                          <th class="text-center" style="width: 200px; min-width: 200px;">
                            修改前值
                          </th>
                          <th class="text-center" style="width: 200px; min-width: 200px;">
                            修改后值
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(item,index) in adjustInfo.detailList">
                          <tr>
                            <td class="text-center">{{item.matterCode}}</td>
                            <td class="text-center">{{item.subjectName}}</td>
                            <td class="text-center">{{item.matterName}}</td>
                            <td class="text-left">是否涉及</td>
                            <td class="text-center">{{item.isInvolveOgn==1?'是':'否'}}</td>
                            <td class="text-center">{{item.isInvolve==1?'是':'否'}}</td>
                          </tr>
                          <tr>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-left">业务月份执行</td>
                            <td class="text-center">
                              <template v-if="item.isInvolveOgn==1">
                                <template v-for="it in item.detailMList">
                                  <template v-if="it.isExecuteOgn==1">
                                    {{it.month}}月:￥{{it.budgetFeeOgn}};
                                  </template>
                                </template>
                              </template>
                              <template v-else>/</template>
                            </td>
                            <td class="text-center">
                              <template v-if="item.isInvolve==1">
                                <template v-for="it in item.detailMList">
                                  <template v-if="it.isExecute==1">
                                    {{it.month}}月:￥{{it.budgetFee}};
                                  </template>
                                </template>
                              </template>
                              <template v-else>/</template>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="hideView"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { default as SpecialCostApi } from "@/api/pd/special/SpecialCostApi.js";
import downloadUtil from "@/util/downloadUtil.js";
export default {
  props: {
    id: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      statusMap: {
        "1": "待审批",
        "2": "审批通过",
        "3": "审批失败"
      },
      filter: {
        costId: null,
        pageNum: 1,
        pageSize: 15
      },
      headers: [
        {
          text: "编号",
          value: "id",
          sortable: false,
          width: 90,
          divider: true,
        },
        {
          text: "调改编号",
          value: "costId",
          sortable: false,
          width: 120,
          divider: true,
        },
        {
          text: "状态",
          sortable: false,
          value: "status",
          width: 90,
          divider: true,
        },
        {
          text: "填单人",
          sortable: false,
          value: "createBy",
          width: 120,
          divider: true,
        },
        {
          text: "填单时间",
          sortable: false,
          value: "createTime",
          width: 180,
          divider: true,
        },
        {
          text: "审批人",
          sortable: false,
          value: "updateBy",
          width: 120,
          divider: true,
        },
        {
          text: "审批时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 180,
          divider: true,
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 150,
          divider: true,
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      importDialog: false,
      importFile: undefined,
      viewDialog: false,
      adjustId: null,
      adjustInfo: {
        detailMList: []
      }
    };
  },
  mounted(){
    // 默认取1
    this.filter.costId = this.id
	  this.getDataFromApi();
  },
  methods:{
    back(){
      this.$emit("back")
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp = await SpecialCostApi.listAdjust(this.filter);
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取事项调改列表失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取事项调改列表情况失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    doImport() {
      this.importDialog = true;
    },
    hideImport() {
      this.importDialog = false;
    },
    async handleImport() {
      let me = this;
      let file = me.importFile;
      if (!file || !file.size) {
        me.$dialog.error({
          text: "文件必传",
          title: "操作失败",
        });
        return;
      }
      let res = await SpecialCostApi.importAdjustData(file,me.id);
      console.log("导入结果", res);
      if (res.data.code === 200) {
        me.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg_detail,
          title: res.data.msg,
        });
      }
      me.hideImport();
      me.importFile = undefined;
    },
    async downloadTemplate() {
      let me = this;
      let res = await SpecialCostApi.importAdjustTemplate();
      downloadUtil.downloadByBlob({ res: res.data, fileName: "专项调改导入模板.xlsx" });
    },
    viewAdjust(item) {
      this.viewDialog = true
      this.adjustId = item.id
      this.getAdjustInfo()
    },
    hideView() {
      this.viewDialog = false
      this.adjustId = null
      this.adjustInfo = {
        detailMList: []
      }
    },
    async getAdjustInfo(){
      let me = this;
      let queryUserResp = await SpecialCostApi.detailAdjust({
        adjustId: me.adjustId
      });
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取预算调改详情失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取预算调改详情情况失败(无会话数据)");
      }
      me.adjustInfo = data.data;
    },
    async clickPassed(){
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认审批通过？",
        title: "提示",
      });
      if (confirm) {
        let res = await SpecialCostApi.adjustPassed(me.adjustId);
        if (res.data.code === 200) {
          me.$dialog.info({
            text:'审批通过',
            title:'操作成功'
          })
          me.viewDialog = false
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作失败",
          });
        }
      }
    },
    async clickUnpassed(){
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认审批不通过？",
        title: "提示",
      });
      if (confirm) {
        let res = await SpecialCostApi.adjustUnpassed(me.adjustId);
        if (res.data.code === 200) {
          me.$dialog.info({
            text:'审批不通过',
            title:'操作成功'
          })
          me.viewDialog = false
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作失败",
          });
        }
      }
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    _jungleStatus(status){
      return this.statusMap[''+status]
    }
  }
};
</script>
<style scoped>
.scroll-wrapper{
  overflow-y: auto;
}
th,td{
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.padding-bottom{
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top{
  padding-top: 30px;
}
.margin-left{
  margin-left: 12px;
}
</style>